import React from 'react';
import { Button } from '@/components/ui/button';
import { Mic, MicOff } from 'lucide-react';
import { useVoiceInput } from '@/hooks/speech/useVoiceInput';
import { useToast } from '@/hooks/use-toast';

interface VoiceInputButtonProps {
  onTranscript: (text: string) => void;
}

export const VoiceInputButton: React.FC<VoiceInputButtonProps> = ({ onTranscript }) => {
  const { toast } = useToast();
  
  const { isListening, isSupported, startListening, stopListening } = useVoiceInput({
    onTranscript: (transcript) => {
      onTranscript(transcript);
      toast({
        title: 'Voice recognized',
        description: `Detected: "${transcript}"`,
      });
    },
  });

  if (!isSupported) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={isListening ? stopListening : startListening}
      className={isListening ? 'animate-pulse text-destructive' : ''}
    >
      {isListening ? (
        <MicOff className="h-4 w-4" />
      ) : (
        <Mic className="h-4 w-4" />
      )}
    </Button>
  );
};
